import { CSSProperties } from 'react'
import { parseColorToRGBA } from '../../../utils'

export const annotationStyles = `
  .annotation-item:hover {
    background-color: var(--tag-color) !important;
  }
  .tag-badge {
    background-color: var(--tag-color) !important;
  }
`

export const customTabsStyle = `
  .custom-tabs {
    border-bottom: 1px solid #333;
  }
  
  .custom-tabs .nav-item .nav-link {
    color: #888;
    background: transparent;
    border: none;
    padding: 0.75rem 1rem;
    transition: all 0.2s ease-in-out;
    position: relative;
  }
  
  .custom-tabs .nav-item .nav-link:hover {
    color: #fff;
    background: transparent;
    border: none;
  }
  
  .custom-tabs .nav-item .nav-link.active {
    color: #fff;
    background: transparent;
    border: none;
  }
  
  .custom-tabs .nav-item .nav-link.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background: rgba(128, 0, 255, 0.8);
    box-shadow: 0 0 8px rgba(128, 0, 255, 0.4);
  }

  .model-tag-badge.badge {
    background-color: var(--bs-badge-bg) !important;
    color: var(--bs-badge-color) !important;
  }
`

export const modelCardStyles = {
  container: {
    backgroundColor: '#1a1a1a',
    border: '1px solid rgba(128, 0, 255, 0.2)',
    borderRadius: '12px',
    padding: '16px',
    boxShadow: '0 4px 12px rgba(128, 0, 255, 0.1)',
    transition: 'all 0.2s ease-in-out',
  },
  title: {
    color: '#fff',
    fontWeight: '600',
    marginBottom: '6px',
    fontSize: '1.1em',
  },
  subtitle: {
    fontSize: '0.85em',
    color: 'rgba(255, 255, 255, 0.6)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  infoBox: {
    backgroundColor: 'rgba(128, 0, 255, 0.1)',
    padding: '8px 12px',
    borderRadius: '8px',
    marginBottom: '12px',
  },
  infoText: {
    fontSize: '0.85em',
    color: 'rgba(255, 255, 255, 0.8)',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '4px',
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoLabel: {
    color: 'rgba(255, 255, 255, 0.6)',
  },
  statusText: {
    color: '#50fa7b',
  },
}

export const buttonStyles = {
  modelChange: {
    backgroundColor: 'rgba(128, 0, 255, 0.1)',
    borderColor: 'rgba(128, 0, 255, 0.3)',
    color: '#fff',
    transition: 'all 0.2s ease-in-out',
  },
  modelChangeHover: {
    backgroundColor: 'rgba(128, 0, 255, 0.2)',
    borderColor: 'rgba(128, 0, 255, 0.4)',
  },
  modelRun: {
    backgroundColor: 'rgba(128, 0, 255, 0.8)',
    borderColor: 'rgba(128, 0, 255, 0.9)',
    transition: 'all 0.2s ease-in-out',
  },
  modelRunHover: {
    backgroundColor: 'rgba(128, 0, 255, 0.9)',
    borderColor: 'rgba(128, 0, 255, 1)',
  },
  zoomControl: {
    backgroundColor: 'rgba(0, 183, 255, 0.1)',
    borderColor: 'rgba(0, 183, 255, 0.3)',
    color: '#fff',
    transition: 'all 0.2s ease-in-out',
  },
  zoomControlHover: {
    backgroundColor: 'rgba(0, 183, 255, 0.2)',
    borderColor: 'rgba(0, 183, 255, 0.4)',
  },
  annotationControl: {
    backgroundColor: 'rgba(138, 43, 226, 0.1)',
    borderColor: 'rgba(138, 43, 226, 0.3)',
    color: '#fff',
    transition: 'all 0.2s ease-in-out',
  },
  annotationControlHover: {
    backgroundColor: 'rgba(138, 43, 226, 0.2)',
    borderColor: 'rgba(138, 43, 226, 0.4)',
  },
  deleteControl: {
    backgroundColor: 'rgba(255, 69, 58, 0.1)',
    borderColor: 'rgba(255, 69, 58, 0.3)',
    color: '#fff',
    transition: 'all 0.2s ease-in-out',
  },
  deleteControlHover: {
    backgroundColor: 'rgba(255, 69, 58, 0.2)',
    borderColor: 'rgba(255, 69, 58, 0.4)',
  },
  viewControl: (showBBoxes: boolean) => ({
    backgroundColor: showBBoxes ? 'rgba(138, 43, 226, 0.8)' : 'rgba(138, 43, 226, 0.1)',
    borderColor: showBBoxes ? 'rgba(138, 43, 226, 0.9)' : 'rgba(138, 43, 226, 0.3)',
    color: '#fff',
    transition: 'all 0.2s ease-in-out',
  }),
  viewControlHover: (showBBoxes: boolean) => ({
    backgroundColor: showBBoxes ? 'rgba(138, 43, 226, 0.9)' : 'rgba(138, 43, 226, 0.2)',
    borderColor: showBBoxes ? 'rgba(138, 43, 226, 1)' : 'rgba(138, 43, 226, 0.4)',
  }),
  selectModelButton: {
    backgroundColor: '#2d1b69',
    borderColor: '#6b4ee6',
    color: '#fff',
  },
}

export const tagStyles = {
  getTagGroupStyle: (
    isFiltered: boolean,
    expandedTags: Set<string>,
    tagId: string,
    tagColor: number
  ) => ({
    backgroundColor: '#1a1a1a',
    borderRadius: '4px',
    opacity: isFiltered || (expandedTags.size > 0 && !expandedTags.has(tagId)) ? 0.5 : 1,
    transition: 'all 0.2s ease-in-out',
    border: `1px solid ${parseColorToRGBA(tagColor, 0.2)}`,
    boxShadow: expandedTags.has(tagId)
      ? `0 0 10px 2px ${parseColorToRGBA(tagColor, 0.13)}`
      : 'none',
    filter: expandedTags.size > 0 && !expandedTags.has(tagId) ? 'grayscale(50%)' : 'none',
  }),
  tagHeader: (tagColor: number): CSSProperties => ({
    backgroundColor: '#1a1a1a',
    cursor: 'pointer',
    borderRadius: '4px',
    transition: 'all 0.2s ease-in-out',
    borderLeft: `4px solid #${tagColor.toString(16).padStart(6, '0')}`,
    position: 'absolute',
  }),
  expandIcon: (isExpanded: boolean) => ({
    transform: `rotate(${isExpanded ? '90deg' : '0deg'})`,
    transition: 'transform 0.2s ease-in-out',
    color: 'rgba(255, 255, 255, 0.8)',
  }),
  tagName: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: '0.9em',
  },
  boxCount: {
    fontSize: '0.75em',
    backgroundColor: '#2a2a2a',
    color: 'rgba(255, 255, 255, 0.7)',
    border: '1px solid #333',
    marginRight: '8px',
  },
  tagCorner: (tagColor: number): CSSProperties => ({
    width: '0',
    height: '0',
    borderStyle: 'solid',
    borderWidth: '0 16px 16px 0',
    borderColor: `transparent #${tagColor.toString(16).padStart(6, '0')} transparent transparent`,
    position: 'absolute',
    top: 0,
    right: 0,
  }),
  label: {
    color: 'white',
    margin: 0,
  },
  noLabels: {
    backgroundColor: '#1a1a1a',
  },
  noAnnotations: {
    backgroundColor: '#1a1a1a',
  },
  tagItem: {
    backgroundColor: '#1a1a1a',
    borderRadius: '4px',
    position: 'relative' as const,
  },
  tagItemContent: (tagColor: number) => ({
    backgroundColor: '#1a1a1a',
    borderRadius: '4px',
    borderLeft: `4px solid #${tagColor.toString(16).padStart(6, '0')}`,
    position: 'relative' as const,
  }),
  tagBoxes: {
    maxHeight: '200px',
    overflowY: 'auto' as const,
    backgroundColor: '#242424',
    margin: '4px',
    borderRadius: '4px',
  },
  tagDot: (tagColor: number, isSelected: boolean) => ({
    width: '3px',
    height: '100%',
    backgroundColor: `#${tagColor.toString(16).padStart(6, '0')}`,
    marginRight: '8px',
    borderRadius: '2px',
    opacity: isSelected ? 1 : 0.6,
  }),
  tagText: (tagColor: number, isSelected: boolean) => ({
    fontSize: '0.9em',
    color: isSelected ? `#${tagColor.toString(16).padStart(6, '0')}` : 'rgba(255, 255, 255, 0.85)',
    fontWeight: isSelected ? '500' : '400',
  }),
  removeButton: {
    background: 'none',
    border: 'none',
    padding: '0',
    marginLeft: '8px',
    cursor: 'pointer',
    color: 'rgba(255, 255, 255, 0.6)',
    display: 'flex',
    alignItems: 'center',
    transition: 'color 0.2s ease-in-out',
  },
  tagGroup: (isFiltered: boolean, expandedTags: Set<string>, tagId: string, tagColor: number) => ({
    ...tagStyles.getTagGroupStyle(isFiltered, expandedTags, tagId, tagColor),
  }),
}

export const snippetStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    maxHeight: '75vh',
    overflow: 'auto',
    padding: '8px',
  } as CSSProperties,
  item: (
    isSelected: boolean,
    isHovered: boolean,
    hoveredBoxIndex: number | undefined
  ): CSSProperties => ({
    position: 'relative',
    transition: 'all 0.3s ease-in-out',
    opacity: hoveredBoxIndex === undefined ? (isSelected ? 1 : 0.7) : isHovered ? 1 : 0.3,
    transform: isSelected ? 'scale(1.02)' : 'scale(1)',
    width: '250px',
    height: '250px',
    filter: hoveredBoxIndex !== undefined && !isHovered ? 'grayscale(50%)' : 'none',
  }),
  thumbnail: (isSelected: boolean, isHovered: boolean): CSSProperties => ({
    borderRadius: '8px',
    cursor: 'pointer',
    border: isSelected ? '3px solid rgba(128, 0, 255, 0.8)' : '1px solid #333',
    boxShadow: isHovered
      ? '0 0 15px rgba(128, 0, 255, 0.5)'
      : isSelected
      ? '0 0 10px rgba(128, 0, 255, 0.4)'
      : 'none',
  }),
}

export const cardStyles = {
  mainCanvas: {
    height: '80vh',
    overflow: 'hidden',
    border: 'none',
  },
  sidePanel: {
    height: '80vh',
    overflow: 'hidden',
    border: 'none',
  },
  sidePanelBody: {
    height: 'calc(100vh-10px)',
    overflowY: 'auto',
    overflowX: 'hidden',
  } as CSSProperties,
}

export const badgeStyles = {
  confidence: (tagColor: number) => ({
    fontSize: '0.75em',
    backgroundColor: `#${tagColor.toString(16).padStart(6, '0')}22`,
    color: `#${tagColor.toString(16).padStart(6, '0')}`,
    border: `1px solid #${tagColor.toString(16).padStart(6, '0')}44`,
    padding: '4px 8px',
    borderRadius: '4px',
  }),
  tabCount: {
    backgroundColor: '#2a2a2a',
    border: '1px solid #333',
    fontSize: '0.75em',
    padding: '0.25em 0.6em',
  },
  confidenceBadge: (tagColor: number) => ({
    fontSize: '0.75em',
    backgroundColor: `#${tagColor.toString(16).padStart(6, '0')}22`,
    color: `#${tagColor.toString(16).padStart(6, '0')}`,
    border: `1px solid #${tagColor.toString(16).padStart(6, '0')}44`,
    padding: '4px 8px',
    borderRadius: '4px',
  }),
  snippetBadge: {
    backgroundColor: '#2a2a2a',
    border: '1px solid #333',
    fontSize: '0.75em',
    padding: '0.25em 0.6em',
  },
}
